<template>
  <div :class="['navigation', { scrolled: isScrolled }]">
    <div v-if="showLanguageModal" class="language-modal-overlay">
      <div class="language-modal">
        <p>请选择语言</p>
        <p>Please select a language</p>
        <div class="language-modal-actions">
          <button @click="selectInitialLanguage('zh')">中文</button>
          <button @click="selectInitialLanguage('en')">English</button>
        </div>
      </div>
    </div>
    <router-link :to="`/`">
      <div class="logo-container" data-aos="fade-right">
        <img
          v-if="!isScrolled"
          :src="
            currentLang === 'en'
              ? require('@/assets/logoEn-1.png')
              : require('@/assets/logo-1.png')
          "
          alt="Logo"
        />
        <img
          v-else
          :src="
            currentLang === 'en'
              ? require('@/assets/logoEn.png')
              : require('@/assets/logo.png')
          "
          alt="Logo"
        />
      </div>
    </router-link>
    <div class="emt-l"></div>
    <slot></slot>
    <div class="emt"></div>
    <div class="contact-2" @click="toggleMenu">
      <span>{{ $t("currentLang") }}</span>
      <img v-if="!isScrolled" src="@/assets/lgimg-1.png" alt="Logo" />
      <img v-else src="@/assets/lgimg.png" alt="Logo" />
      <div v-show="menuVisible" class="language-menu">
        <div @click="switchLanguage('zh')">中文</div>
        <div @click="switchLanguage('en')">English</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Navigation",
  computed: {
    currentLang() {
      return this.$i18n.locale;
    },
  },
  data() {
    return {
      isScrolled: false,
      menuVisible: false,
      showLanguageModal: false,
    };
  },
  mounted() {
    this.initLanguageSelection();
    this.checkRoute();
    this.$router.afterEach(() => {
      this.checkRoute();
    });
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    initLanguageSelection() {
      const languageSelected = localStorage.getItem("languageSelected");
      if (!languageSelected) {
        this.showLanguageModal = true;
      }
    },
    selectInitialLanguage(lang) {
      this.switchLanguage(lang);
      localStorage.setItem("languageSelected", "true");
      localStorage.setItem("preferredLanguage", lang);
      this.showLanguageModal = false;
    },
    handleScroll() {
      if (this.shouldAlwaysBeScrolled()) return;
      const vw = window.innerHeight / 100;
      this.isScrolled = window.scrollY > 30 * vw;
    },
    checkRoute() {
      if (this.shouldAlwaysBeScrolled()) {
        this.isScrolled = true;
        window.removeEventListener("scroll", this.handleScroll);
      } else {
        this.isScrolled = window.scrollY > 30 * (window.innerHeight / 100);
        window.addEventListener("scroll", this.handleScroll);
      }
    },
    shouldAlwaysBeScrolled() {
      const routesNeverScrolled = [
        "/home",
        "/about",
        "/contact",
        "/join",
        "/",
        "/en/home",
        "/en/about",
        "/en/contact",
        "/en/join",
        "/en/",
      ];
      const currentPath = this.$route.path;
      return (
        !routesNeverScrolled.includes(currentPath) &&
        !currentPath.startsWith("/news") &&
        !currentPath.startsWith("/products") &&
        !currentPath.startsWith("/en/news") &&
        !currentPath.startsWith("/en/products") &&
        !currentPath.startsWith("/en/detail") &&
        !currentPath.startsWith("/detail")
      );
    },
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
    },
    switchLanguage(lang) {
      const currentLang = this.$i18n.locale;

      // 只在目标语言与当前语言不同时执行切换
      if (currentLang === lang) return;

      this.$i18n.locale = lang;

      const path = this.$route.path;
      let newPath;

      if (lang === "en") {
        // 添加 /en 前缀
        newPath = path.startsWith("/en") ? path : `/en${path}`;
      } else {
        // 去掉 /en 前缀
        newPath = path.startsWith("/en") ? path.replace("/en", "") : path;
      }

      // 使用 replace 方法替代 push 方法以避免产生额外的历史记录
      this.$router.replace(newPath || "/");
      localStorage.setItem("preferredLanguage", lang);
    },
  },
};
</script>

<style scoped>
.navigation {
  display: flex;
  align-items: center;
  background: transparent;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9999;
  transition: background-color 0.5s ease;
}

.navigation.scrolled {
  background: #ffffff;
  color: #000;
}

.navigation.scrolled .tabbar-item,
.navigation.scrolled .contact,
.navigation.scrolled .contact-2 {
  color: #00000090;
}

.logo-container {
  width: 260px;
}

.logo-container img {
  width: 50%;
  height: auto;
}

.slot-container {
  flex: 1;
  display: flex;
}

.emt-l {
  width: 6vw;
}

.emt {
  width: 15vw;
}

.contact-2 img {
  width: 20px;
  height: 10px;
  padding-right: 5px;
}

.contact-2 {
  color: #fff;
  padding: 15px 10px 10px 20px;
  cursor: pointer;
}

.navigation.scrolled {
  color: #00000090;
}

.language-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: #fff;
  color: #000;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  z-index: 1000;
}

.language-menu div {
  padding: 10px;
  cursor: pointer;
}

.language-menu div:hover {
  background-color: #f0f0f0;
}

.language-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10001;
}

.language-modal {
  background: #fff;
  color: #000;
  padding: 24px;
  border-radius: 8px;
  min-width: 280px;
  text-align: center;
}

.language-modal p {
  margin: 0 0 5px;
}

.language-modal-actions {
  display: flex;
  gap: 30px;
  justify-content: center;
  margin-top: 20px;
}

.language-modal-actions button {
  border: 1px solid #ccc;
  background: #fff;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.language-modal-actions button:hover {
  background: #018fd7;
  color: #fff;
}

@media (max-width: 768px) {
  .contact-2 {
    position: absolute;
    right: 10px; /* 设置靠右的距离 */
    top: 50%; /* 垂直居中对齐 */
    transform: translateY(-50%); /* 垂直居中对齐 */
  }

  .navigation.scrolled .tabbar-item {
    color: #00000090;
  }

  .tabbar-item {
    color: #00000090;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tabbar/Navigation.vue